module.exports = __webpack_public_path__ + "36d47f6fcd79a829ae1cd498a2597a07.svg";